module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('doc-section', {
    attrs: {
      "id": "alert",
      "name": "Alert"
    }
  }, [_c('div', {
    staticClass: "bs-example"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    on: {
      "click": function($event) {
        _vm.showTop = !_vm.showTop
      }
    }
  }, [_vm._v("\n      Click to toggle alert on top\n    ")]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": 3000,
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.showTop),
      callback: function($$v) {
        _vm.showTop = $$v
      },
      expression: "showTop"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Heads up!")]), _vm._v(" "), _c('p', [_vm._v("This alert needs your attention.")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-lg",
    on: {
      "click": function($event) {
        _vm.showRight = !_vm.showRight
      }
    }
  }, [_vm._v("\n      Click to toggle alert on right\n    ")]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top-right",
      "duration": 3000,
      "type": "success",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.showRight),
      callback: function($$v) {
        _vm.showRight = $$v
      },
      expression: "showRight"
    }
  }, [_c('span', {
    staticClass: "icon-ok-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Well Done!")]), _vm._v(" "), _c('p', [_vm._v("You successfully read this important alert message.")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('alert', {
    attrs: {
      "type": "success"
    }
  }, [_c('strong', [_vm._v("Well Done!")]), _vm._v("\n      You successfully read this important alert message.\n    ")]), _vm._v(" "), _c('alert', {
    attrs: {
      "type": "info"
    }
  }, [_c('strong', [_vm._v("Heads up!")]), _vm._v(" This alert needs your attention, but it's not super important.\n    ")]), _vm._v(" "), _c('alert', {
    attrs: {
      "type": "danger",
      "dismissable": ""
    }
  }, [_c('strong', [_vm._v("Oh snap!")]), _vm._v(" Change a few things up and try submitting again.\n    ")]), _vm._v(" "), _c('alert', {
    attrs: {
      "type": "warning",
      "dismissable": ""
    }
  }, [_c('strong', [_vm._v("Warning!")]), _vm._v(" Better check yourself, you're not looking too good.\n    ")])], 1), _vm._v(" "), _c('doc-code', {
    attrs: {
      "language": "markup"
    }
  }, [_vm._v("\n    <alert type=\"success/info/danger/warning\">\n      ...\n    </alert>\n\n    <alert v-model=\"showRight\" placement=\"top-right\" duration=\"3000\" type=\"success\" width=\"400px\" dismissable>\n      <span class=\"icon-ok-circled alert-icon-float-left\"></span>\n      <strong>Well Done!</strong>\n      <p>You successfully read this important alert message.</p>\n    </alert>\n\n    <alert v-models=\"showTop\" placement=\"top\" duration=\"3000\" type=\"danger\" width=\"400px\" dismissable>\n      <span class=\"icon-info-circled alert-icon-float-left\"></span>\n      <strong>Heads up!</strong>\n      <p>This alert needs your attention.</p>\n    </alert>\n  ")]), _vm._v(" "), _c('doc-table', [_c('div', [_c('p', [_vm._v("value")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("true")])]), _vm._v(" "), _c('p', [_vm._v("Whether show the component")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("dismissable")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("false")])]), _vm._v(" "), _c('p', [_vm._v("Whether show close button")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("type")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("String")]), _vm._v(", one of\n      "), _c('code', [_vm._v("success")]), _vm._v(" "), _c('code', [_vm._v("info")]), _vm._v(" "), _c('code', [_vm._v("warning")]), _vm._v(" "), _c('code', [_vm._v("danger")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("success")])]), _vm._v(" "), _c('p', [_vm._v("Components styles")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("duration")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("0")])]), _vm._v(" "), _c('p', [_vm._v("Auto close duration. Set "), _c('code', [_vm._v("0")]), _vm._v(" or a negative number will NOT be auto-close.")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("width")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', [_c('p', [_vm._v("placement")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("String")]), _vm._v(". one of "), _c('code', [_vm._v("top")]), _vm._v(", "), _c('code', [_vm._v("top-right")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("how to position the component.")])])])], 1)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5ef75682", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5ef75682!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/example/alertDocs.vue
// module id = 130
// module chunks = 0